/** @jsxImportSource @emotion/react */
import { Tooltip } from '@mui/material';
import { useRef, useState, useEffect } from 'react';

interface OverflowTooltipProps {
  children: string;
}

const OverflowTooltip = ({ children }: OverflowTooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkOverflow = () => {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => observer.disconnect();
  }, [children]);

  return (
    <Tooltip title={showTooltip ? children : ''} arrow disableHoverListener={!showTooltip}>
      <div
        ref={ref}
        style={{
          width: '100%',
          overflow: 'inherit',
          whiteSpace: 'inherit',
          textOverflow: 'inherit',
        }}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default OverflowTooltip;
